module.exports = __webpack_public_path__ + "img/bmt.9ddb9c09.png";